// Wraps elements in a div, with an optional class
function wrap(el, wrapper, wrapperClass) {
    el.parentNode.insertBefore(wrapper, el);

    if (wrapperClass != null) {
        if (Array.isArray(wrapperClass)) {
            wrapper.classList.add(...wrapperClass);
        } else {
            wrapper.classList.add(wrapperClass);
        }
    }

    wrapper.appendChild(el);
}

// ------------------------------------------------------------
// Wrap each table (within .cms-content element) in a div with overflow and styling classes
// TODO: Add a function to wrap all tables added via the WP editor in div.table-overflow-container.overflow-container
// ------------------------------------------------------------

function wrapTables(
    tables = Array(),
    tableWrapperClassName = "table-overflow-container",
    overflowWrapperClassName = "overflow-container"
) {
    for (let i = 0; i < tables.length; i++) {
        if (!tables[i].parentNode.classList.contains(tableWrapperClassName)) {
            wrap(tables[i], document.createElement("div"), [overflowWrapperClassName, tableWrapperClassName]);
        }
    }
}

export default wrapTables;
